import React, { Component } from 'react'
import { withRouter } from "react-router";
import { NavLink } from "react-router-dom";
import Menu from './Menu';
import $ from 'jquery';

export class Header extends Component {

    constructor( props ){

        super();

        this.state = {
            subSite: false,
            menuOpened: false,
            isMobile: false
        };
        this.timeResize = false;
        this.$toggle = $( '.menu-toggle' );

        this.setMenuState = this.setMenuState.bind( this );

    }

    setMenuState = ( menuOpened ) => {
        this.setState({
            menuOpened: menuOpened
        });
    }
    
    componentDidMount(){

        this.checkSize();

        // Bind when router changes
        const { history } = this.props;
        // First time
        this.checkTitle( history.location );
        // Binder
        history.listen((location) => { 
            this.checkTitle( location );
        });

        window.addEventListener( 
            'resize', 
            () => {
                if(  this.timeResize ) clearTimeout( this.timeResize );
                this.timeResize = this.checkSize();
            }, 
            true 
        );
    
    }

    shouldComponentUpdate

    checkTitle( location ){
        const subSite = ( location.pathname.indexOf( '/blogbbp' ) === 0 ) ? 'blogbbp' : false;
        this.setState({ subSite });
    }

    componentWillUnmount(){
        window.removeEventListener( 'resize', this.checkSize );
    }

    checkSize = () => {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        this.setState({
            isMobile: width <= 960
        })
    }

    clickToggle = ( event ) => {
        
        this.setState( state => {
            return {
                menuOpened: state.menuOpened ? false : true
            }
        });

    };

    render(){

        const 
            { name, key, id, logo } = this.props.siteData,
            { subSite, menuOpened, isMobile } = this.state,
            //plainLogo = ( logo !== undefined && logo !== false ) ? logo : false,
            plainLogo = false,
            menuClass = menuOpened ? 'opened' : '',
            notFound = !id,
            headerClass = 'App-header' + ( notFound ? ' not-found' : '' ) + ( logo !== undefined ? ' with-logo' : '' ),
            API_URL = process.env.REACT_APP_API_URL
        ;

        // Home link
        var homeLink = false;
        if( subSite === 'blogbbp' ){
            homeLink = {
                title : 'Blog BBP',
                url : '/blogbbp'
            };
        }
        else if( key !== 'home' ){
            homeLink = {
                title : name,
                url : '/'
            };
        }
        
        return (
            <header className={headerClass} id="masthead">
                <div className="wcf">
                    <a href={API_URL} title="BB Previdência">
                        <h1>
                            <svg width="220" height="60" viewBox="0 0 340 92">
                                <rect fill="#fff200" x="0" width="340" height="92"/>
                                <g>
                                    <path fill="#0060a9" d="M27.27,60.97l4.1-2.74,4.11,2.74-8.21,5.48v-5.48h0ZM66.69,32.5l-4.11,2.74-4.1-2.74,8.21-5.47v5.47h0ZM66.69,53.31l-8.21-5.48-9.85,6.57,4.1,2.74-5.34,3.55-11.5-7.66,18.89-12.59-4.1-2.74-23.4,15.61,19.71,13.13,19.71-13.13h0ZM27.27,40.16l8.21,5.47,9.86-6.57-4.1-2.74,5.34-3.56,11.5,7.66-18.89,12.59,4.1,2.74,23.41-15.6-19.71-13.14-19.71,13.14Z"/>
                                    <path fill="#0060a9" d="M113.08,46.36v-.11c3.46-.62,5.16-2.89,5.16-6.07,0-5.84-3.97-7.09-8.79-7.09h-11.29v27.51h11.23c2.73,0,9.36-.28,9.36-7.26,0-3.8-1.14-6.41-5.68-6.98ZM105.26,37.35h3.35c1.81.11,2.78,1.53,2.78,3.45,0,2.38-1.65,3.52-2.61,3.52h-3.52v-6.97ZM108.6,56.35c-.17.05-.4.05-.57.05h-2.78v-7.83h3.35c2.32.17,3.35,1.82,3.35,3.92,0,3.18-1.93,3.8-3.35,3.86ZM91.19,46.36v-.11c3.41-.62,5.16-2.89,5.16-6.07,0-5.84-4.03-7.09-8.85-7.09h-11.23v27.51h11.17c2.72,0,9.42-.28,9.42-7.26,0-3.8-1.19-6.41-5.67-6.98ZM83.36,37.35h3.35c1.76.11,2.72,1.53,2.72,3.45,0,2.38-1.59,3.52-2.61,3.52h-3.46v-6.97ZM86.7,56.35c-.22.05-.39.05-.57.05h-2.77v-7.83h3.35c2.27.17,3.35,1.82,3.35,3.92,0,3.18-1.98,3.8-3.35,3.86ZM163.8,43.64c0-3.86-2.27-5.84-5.85-5.84h-10.77v22.46h5.89v-19.06h1.93c1.7,0,3.12,1.19,3.12,3.4,0,1.87-.97,3.4-2.44,3.34h-1.64l5.33,12.31h5.21l-4.88-10.83c2.89-.56,4.09-2.38,4.09-5.78ZM238.62,32.47l2.44,3.4h4.43l-4.53-5.45h-4.66l-4.48,5.45h4.48l2.33-3.4ZM136.68,32.75h-11.4v27.51h7.1v-11.23h3.91c7.43,0,8.45-4.93,8.45-8.11,0-5-2.27-8.17-8.06-8.17ZM135.15,44.78h-2.78v-7.78h2.78c1.36.17,2.77,1.42,2.77,4.09,0,2.16-1.92,3.69-2.77,3.69ZM287.35,60.26h5.79v-22.35h-5.79v22.35ZM277.08,57.42c-2.21,0-2.44-3.29-2.44-8.4,0-4.19-.28-8.34,2.44-8.34,1.02,0,2.16,1.76,2.16,4.15h5.39c.23-4.88-2.21-7.55-7.54-7.55-8.68,0-8.39,5.73-8.39,11.75s-.29,11.8,8.39,11.8c5.79,0,7.82-1.93,7.82-8.06h-5.38c0,1.93-.74,4.65-2.44,4.65ZM172.47,50.28h7.32v-3.46h-7.32v-5.51h7.94v-3.4h-13.72v22.35h14.01v-3.46h-8.23v-6.52ZM260.75,53.06h-.06l-5.16-15.15h-7.83v22.35h5.39v-16.05h.11l5.33,16.05h7.6v-22.35h-5.39v15.15ZM309.13,37.91h-6.81l-6.81,22.35h5.67l1.42-4.99h5.79l1.36,4.99h6.07l-6.7-22.35ZM303.29,51.86l2.1-9.19h.06v.11l2.15,9.08h-4.31ZM192.45,54.13h-.11l-3.35-16.34h-6.01l5.78,22.46h6.81l6.18-22.46h-5.61l-3.69,16.34ZM237.43,50.28h7.32v-3.46h-7.32v-5.51h7.94v-3.4h-13.73v22.35h14.01v-3.46h-8.23v-6.52ZM204.36,60.26h5.73v-22.35h-5.73v22.35ZM221.09,37.91h-8.62v22.35h8.39c8.91,0,8.23-6.69,8.23-11.34,0-8.23-1.25-11.01-8.01-11.01ZM220.86,56.74c-.22.06-.45.06-.74.06h-1.87v-15.49h2.04c.18,0,.4,0,.57.06,2.5.46,2.67,4.08,2.67,7.66,0,5.05-.61,7.32-2.67,7.71Z"/>
                                </g>
                            </svg>
                            {/* <img src={logoBBPrev} className="App-logo" alt="logo" /> */}
                        </h1>
                    </a>
                    {
                        homeLink
                        ? <h2>
                            <NavLink to={homeLink.url} title={homeLink.title}>
                                {plainLogo && <img src={logo} alt={name} />}
                                {!plainLogo && homeLink.title }
                            </NavLink>
                        </h2>
                        : null
                    }
                    <div id="menu-wrapper" className={menuClass}>
                        {
                            notFound
                            ? ''
                            : <Menu siteData={this.props.siteData} menuOpened={menuOpened} isMobile={isMobile} setMenuState={this.setMenuState} />
                        }
                        <a href="https://login.bbprevidencia.com.br" className="button" title="Minha Previdência" target="_blank" rel="noreferrer">Minha Previdência</a>
                    </div>
                </div>
                <div className={ 'menu-toggle ' + menuClass } onClick={this.clickToggle}>
                    <span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </div>
            </header>
        );

    }

}

export default withRouter( Header );